import { inject, Injectable, Injector } from '@angular/core';
import { ConnectorBaseService } from '@libs/shared/common';
import { ConnectionAuthModel, ConnectionAuthProvider, ConnectionParams, EndpointType, RemoteServiceType } from '@libs/shared/models';
import { Observable, of, switchMap, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConnectorService {
  private readonly injector: Injector = inject(Injector);
  private readonly connectorBase: ConnectorBaseService = inject(ConnectorBaseService);

  public connect<
    T, S extends RemoteServiceType = RemoteServiceType, E extends EndpointType<S> = EndpointType<S>,
  >(service: S, endpoint: E, params?: ConnectionParams): Observable<T> {
    return this.getAuth().pipe(
      take(1),
      switchMap(auth => this.connectorBase.connect<T>(service, endpoint, auth, params)),
    );
  }

  private getAuth(): Observable<ConnectionAuthModel | undefined> {
    return this.injector.get(ConnectionAuthProvider, null)?.getAuth() ?? of(undefined);
  }
}
